import React from "react";
import { Link } from "react-scroll";


import style from "./navbar.module.css";


const Navbar = () => {
   

  return (
    <div id="top">
    <div className={style.nav}>
      <div className={style.navsubdiv1} >
        <img
          src="https://www.pngplay.com/wp-content/uploads/6/Black-Stylish-Army-Logo-Transparent-PNG.png"
          alt=""
        />
        <p className={style.bold}><Link className={style.bold} activeClass="active" to="top" spy={true} smooth={true}>P.P</Link></p>
      </div>
      <div className={style.navsubdiv2}>
        <div className={style.res}>
          <i className="fa-solid fa-file"></i>
          <p><a href={require("../pdf/Resume.pdf")} download="PrakarshResume">Resume</a></p>
        </div>
        <div className={style.resn} >
          <i className="fa-solid fa-computer"></i>
          <p><Link to="skills" spy={true} smooth={true}>Skills</Link></p>
        </div>
        
        <div className={style.resn}  >
          <i className="fa-solid fa-hand-holding-hand"></i>
          <p><Link to="projects" spy={true} smooth={true}>Projects</Link></p>
        </div>

        <div className={style.resn} >
          <i className="fa-solid fa-phone"></i>
          <p><Link to="contact" spy={true} smooth={true}>Contact</Link></p>
        </div>
        
      </div>
      
      
     
    </div>
    
        
    </div>
  );
};

export default Navbar;
